<template>
    <v-dialog v-model="visible" :width="dialogWidth" @keydown.esc="visible = false">
        <v-toolbar dense color="primary">
            <v-toolbar-title>Part: {{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="visible = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card>
            <v-img :src="imagePath" v-if="imagePath"></v-img>
            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="visible = false">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'ImageDialog',
  props: {
  },
  data () {
    return {
      imageRoot: process.env.VUE_APP_ROOT_API_IMAGE,
      title: null,
      visible: false,
      imagePath: null
    }
  },
  computed: {
    dialogWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '350px'
        default: case 'sm': return '700px'
      }
    }
  },
  methods: {
    getBase64 (url) {
      return this.axios.get(url, { responseType: 'arraybuffer' })
        .then((response) => {
          let image = btoa(
            new Uint8Array(response.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
        })
    },
    async show (part) {
      this.title = part
      this.imagePath = await this.getBase64(`${this.imageRoot}/${part}`)
      this.$log.debug(this.imagePath)
      this.visible = true
    },
    hide () {
      this.visible = false
      this.imagePath = null
    }
  }
}
</script>

<style scoped>

</style>
